<template>
  <div
    class="productSection"
    :class="{
      'productSection--titlePadding': paddingOnlyTitle,
      'productSection--mobileFull': mobileFull,
      'productSection--disableMobileBg': disableMobileBackground,
      'productSection--disableMarginBottom': disableMarginBottom,
    }"
  >
    <div v-if="title" class="productSection__title">
      {{ title }}
      <template v-if="hTag">
        <br />
        <component :is="hTag ? 'h2' : 'span'" class="productSection__titleName"
          >{{ productName }}
        </component>
      </template>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProductSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
    paddingOnlyTitle: {
      type: Boolean,
      default: false,
    },
    mobileFull: {
      type: Boolean,
      default: false,
    },
    disableMobileBackground: {
      type: Boolean,
      default: false,
    },
    disableMarginBottom: {
      type: Boolean,
      default: false,
    },
    hTag: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.productSection {
  $root: &;
  margin-bottom: 3rem;
  background-color: $cWhite;
  padding: 3rem;

  @include rwd('small-tablet') {
    padding: 3rem 2rem;
  }

  &--outlet {
    font-size: 2.8rem;

    #{$root}__title {
      font-size: 2.8rem;
    }
  }

  &__title {
    display: block;
    margin-bottom: 3rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;

    @include rwd('small-tablet') {
      font-size: 3rem;
      line-height: 3.8rem;
      text-align: center;
      margin-bottom: 2.5rem;
    }
  }

  &__titleName {
    font-size: 2.1rem;
    line-height: 3.1rem;
    color: $cAddDark02;
  }

  &--titlePadding {
    padding: 3rem 0 2rem;

    #{$root}__title {
      padding-left: 3rem;
      margin-bottom: 2rem;

      @include rwd('small-tablet') {
        padding-left: 0;
      }
    }
  }

  &--mobileFull {
    @include rwd('small-tablet') {
      flex: 0 0 calc(100% + 40px);
      max-width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
    }
  }

  &--disableMobileBg {
    @include rwd('tablet') {
      background-color: inherit;
      padding-top: 1rem;
    }
  }

  &--disableMarginBottom {
    margin-bottom: 0;
  }
}
</style>
